module.exports = __webpack_public_path__ + "static/media/Concept_Garden_01.108bf31e.jpg";